import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const lvTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Vārds (mazie burti, bez īpašām rakstzīmēm)',
    add: 'Pievienot',
    allowedFileTypes: 'Atļautie failu tipi',
    allowedFileTypesDescription:
      'Ierobežojiet atļautos failu tipus (piemēram, attēls/*, lietojumprogramma/pdf). Atstājiet tukšu, lai atļautu visus veidus.',
    allowMultipleFiles: 'Atļaut vairākus failus',
    amountInCents: 'Summa centos',
    basePrice: 'Bāzes cena',
    bcc: 'BCC',
    brand: 'Zīmols',
    cc: 'CC',
    checkboxPlural: 'Izvēles rūtiņas lauki',
    checkboxSingular: 'Izvēles rūtiņa',
    checkedByDefault: 'Atzīmēts pēc noklusējuma',
    chooseConfirmationType:
      'Izvēlieties, vai pēc veidlapas iesniegšanas rādīt lapā ziņojumu vai novirzīt uz citu lapu.',
    condition: 'Stāvoklis',
    confirmationMessage: 'Apstiprinājuma ziņojums',
    confirmationType: 'Apstiprinājuma veids',
    countryPlural: 'Valsts lauki',
    countrySingular: 'Valsts',
    creditCard: 'Kredītkarte',
    customURL: 'Pielāgots URL',
    datePlural: 'Datuma lauki',
    dateSingular: 'Datums',
    defaultValue: 'Noklusējuma vērtība',
    divide: 'Sadaliet',
    documentToLinkTo: 'Dokuments, uz kuru izveidot saiti',
    doesNotEqual: 'Nav vienāds',
    emailFrom: 'E-pasts no',
    emailPlural: 'E-pasta lauki',
    emailsDescription:
      'Nosūtiet pielāgotus e-pasta ziņojumus, kad veidlapa ir iesniegta. Izmantojiet komatu atdalītus sarakstus, lai nosūtītu vienu un to pašu e-pasta ziņojumu vairākiem adresātiem. Lai atsauktos uz vērtību no šīs veidlapas, ievietojiet lauka nosaukumu ar dubultām iekavām, t.i., {{firstName}}. Varat izmantot aizstājējzīmi {{*}}, lai izvadītu visus datus, un {{*:table}}, lai e-pastā tos formatētu kā HTML tabulu.',
    emailSingular: 'E-pasts',
    emailTo: 'E-pasts uz',
    equals: 'Vienāds',
    field: 'Lauks',
    fields: 'Lauki',
    fieldWidth: 'Lauka platums (procentos)',
    hasAnyValue: 'Ir kāda vērtība',
    internalLink: 'Iekšējā saite',
    label: 'Etiķete',
    maxFileSize: 'Maksimālais faila lielums (baitos)',
    maxFileSizeDescription: 'Maksimālais faila lielums baitos. Atstājiet tukšu bez ierobežojumiem.',
    message: 'Ziņa',
    messageDescription: 'Ievadiet ziņojumu, kas jānosūta šajā e-pastā.',
    messagePlural: 'Ziņojumu bloki',
    messageSingular: 'Ziņa',
    mimeType: 'MIME tips',
    mimeTypePlural: 'MIME veidi',
    mimeTypeSingular: 'MIME tips',
    multiply: 'Pavairot',
    numberPlural: 'Skaitļu lauki',
    numberSingular: 'Numurs',
    optionPlural: 'Iespējas',
    optionSingular: 'Opcija',
    paymentFieldPlural: 'Maksājumu lauki',
    paymentFieldSingular: 'Maksājums',
    paymentProcessor: 'Maksājumu apstrādātājs',
    paymentStatus: 'Statuss',
    placeholder: 'Vietturis',
    priceConditions: 'Cenas nosacījumi',
    priceConditionsPlural: 'Cenas nosacījumi',
    priceConditionsSingular: 'Cenas stāvoklis',
    radioOptions: 'Radio atribūtu opcijas',
    radioPlural: 'Radio lauki',
    radioSingular: 'Radio',
    redirect: 'Novirzīt',
    replyTo: 'Atbildēt uz',
    required: 'Obligāti',
    selectOptions: 'Izvēlieties Iespējas',
    selectPlural: 'Atlasiet Lauki',
    selectSingular: 'Izvēlieties',
    statePlural: 'Štatu lauki',
    stateSingular: 'valsts',
    staticValue: 'Statiskā vērtība',
    subject: 'Priekšmets',
    submitButton: 'Iesniegt pogas etiķeti',
    subtract: 'Atņemt',
    textareaPlural: 'Teksta apgabala lauki',
    textareaSingular: 'Teksta apgabals',
    textPlural: 'Teksta lauki',
    textSingular: 'Teksts',
    title: 'Nosaukums',
    token: 'žetons',
    uploadCollection: 'Augšupielādēt kolekciju',
    uploadCollectionDescription: 'Atlasiet, kurā augšupielādes kolekcijā saglabāt failus',
    uploadFieldPlural: 'Augšupielādēt laukus',
    uploadFieldSingular: 'Augšupielādēt',
    urlToRedirectTo: 'URL, uz kuru novirzīt',
    value: 'Vērtība',
    valueOfField: 'Lauka vērtība',
    valueType: 'Vērtības veids',
  },
}

export const lv: PluginLanguage = {
  dateFNSKey: 'lv',
  translations: lvTranslations,
}
